import React from 'react';
import { Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import styles from './RefundStep2.module.scss';
import FAQSection from '../OrderServicePanel/FAQSection';
import StepBar from './StepBar';


interface RefundStep2Props {
  formData: any;
  order?: any;
  onBack: () => void;
  onNext: () => void;
  serviceType?: 'refundOnly' | 'refundAndReturn';
  stepData?: string[];
  currentStep?: number;
}

const RefundStep2: React.FC<RefundStep2Props> = ({ formData, order, onBack, onNext, serviceType, stepData, currentStep }) => {
  // 有数据用数据，没数据用假数据/占位符
  const sellerName = formData?.sellerName || order?.sellerName || 'Apple Store';
  const userName = formData?.userName || order?.userName || 'Mike';
  const userAvatar = formData?.userAvatar || order?.userAvatar || 'https://randomuser.me/api/portraits/men/32.jpg';
  const remainTime = formData?.remainTime || '23 : 59 : 50';
  const refundReason = formData?.refundReason || order?.refundReason || 'Changed Mind';
  const refundAmount = formData?.refundAmount || order?.refundAmount || '5.99';
  const refundType = formData?.serviceType === 'refund' ? 'Refund' : (formData?.serviceType === 'return' ? 'Return and Refund' : (order?.serviceType === 'refund' ? 'Refund' : (order?.serviceType === 'return' ? 'Return and Refund' : 'Refund')));
  const product = formData?.product || (order?.products ? order.products[0] : {}) || {};
  const productImg = product?.img || order?.products?.[0]?.img || 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308';
  const productTitle = product?.title || order?.products?.[0]?.title || 'Handmade Bamboo Basket: Woven with Bamboo...';
  const productClass = product?.classification || order?.products?.[0]?.classification || 'Shape Classification...';
  const orderNumber = formData?.orderNumber || order?.orderNumber || '14785236987463157245';
  const unitPrice = product?.price || order?.products?.[0]?.price || '5.99';
  const shippingFee = product?.shippingFee || order?.products?.[0]?.shippingFee || '0.00';
  const totalPrice = product?.totalPrice || order?.products?.[0]?.totalPrice || unitPrice;
  const refundNumber = formData?.refundNumber || orderNumber;
  const goodsStatus = formData?.goodsState === 'not_received' ? 'Not shipped' : (formData?.goodsState === 'received' ? 'Shipped' : (order?.goodsState === 'not_received' ? 'Not shipped' : (order?.goodsState === 'received' ? 'Shipped' : 'Not shipped')));
  const negotiationHistory = formData?.negotiationHistory || order?.negotiationHistory || [
    {
      userName,
      userAvatar,
      time: formData?.createdAt || order?.createdAt || '2025-07-01 10:20:20',
      action: 'Initiated A Refund Request',
      refundType,
      refundAmount,
      refundReason
    }
  ];

  // 进度条流程（如需可隐藏）
  // const processSteps = [
  //   {
  //     title: 'Refund Request Submitted',
  //     description: 'Your refund request has been successfully submitted',
  //     status: 'finish',
  //     icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />
  //   },
  //   {
  //     title: 'Under Review',
  //     description: 'Seller is reviewing your refund request',
  //     status: 'process',
  //     icon: <ClockCircleOutlined style={{ color: '#1890ff' }} />
  //   },
  //   {
  //     title: 'Processing',
  //     description: 'Refund is being processed by the seller',
  //     status: 'wait',
  //     icon: <ClockCircleOutlined style={{ color: '#d9d9d9' }} />
  //   },
  //   {
  //     title: 'Completed',
  //     description: 'Refund has been completed',
  //     status: 'wait',
  //     icon: <ClockCircleOutlined style={{ color: '#d9d9d9' }} />
  //   }
  // ];

  return (
    <div className={styles['']}>
      <StepBar currentStep={currentStep || 2} stepData={stepData} />
      <div className={styles['refund-step2-layout']}>
        {/* 左侧主内容区 */}
        <div className={styles['main-panel']}>
          <div className={styles['top-status']}>
            <span className={styles['wait-title']}>
              Please Wait For The Merchant To Process. <span className={styles['wait-timer']}><CheckCircleOutlined /> {remainTime} Remaining</span>
            </span>
            <div className={styles['wait-desc']}>
              You Have Successfully Initiated A Refund Request. Please Wait Patiently While The Seller Processes It
            </div>
            <div className={styles['wait-tip']}>
              <span className={styles['dot']}></span>
              If the seller rejects your request, you can modify the refund application and resubmit it. The seller will then process it again.
            </div>
            <Button type="primary" className={styles['modify-btn']}>Modify Application</Button>
            <Button type="default" className={styles['next-btn']} onClick={onNext} style={{ marginTop: 8 }}>Next</Button>
            <div className={styles['withdraw-row']}>
              You Can Also: <Button type="link" className={styles['withdraw-link']}>Withdraw Application</Button>
            </div>
          </div>
          <div className={styles['history-title']}>Negotiation History</div>
          <div className={styles['history-list']}>
            {negotiationHistory.map((item: any, idx: number) => (
              <div className={styles['history-item']} key={idx}>
                <img className={styles['avatar']} src={item.userAvatar} alt="avatar" />
                <div className={styles['history-info']}>
                  <div className={styles['history-header']}>
                    <span className={styles['user-name']}>{item.userName}</span>
                    <span className={styles['history-time']}>{item.time}</span>
                  </div>
                  <div className={styles['history-action']}>{item.action}</div>
                  <div className={styles['history-detail']}>
                    <div><span>Refund Type:  </span>  {item.refundType}  </div>
                    <div><span>Refund Amount: </span>  {item.refundAmount}</div>
                    <div><span>Refund Reason: </span>  {item.refundReason}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* 右侧详情区 */}
        <div className={styles['side-panel']}>
          <div className={styles['side-title']}>Refund Details</div>
          <div className={styles['side-product']}>
            <img className={styles['side-img']} src={productImg} alt="product" />
            <div className={styles['side-info']}>
              <div className={styles['side-title-main']}>{productTitle}</div>
              <div className={styles['side-class']}>{productClass}</div>
            </div>
          </div>
          <div className={styles['side-list']}>
            <div><span>Seller:</span> {sellerName}</div>
            <div><span>Order Number:</span> {orderNumber}</div>
            <div><span>Unit Price:</span> ${unitPrice}</div>
            <div><span>Shipping Fee:</span> ${shippingFee}</div>
            <div><span>Total Price:</span> ${totalPrice}</div>
            <div className={styles['side-list-box']}></div>
            <div><span>Refund Number:</span> {refundNumber}</div>
            <div><span>Refund Amount:</span> {refundAmount}</div>
            <div><span>Refund Reason:</span> {refundReason}</div>
            <div><span>Request:</span> {refundType}</div>
            <div><span>Goods status:</span> {goodsStatus}</div>
          </div>
        </div>
      </div>
      <FAQSection />
    </div>
  );
};

export default RefundStep2; 